import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32rem;
`;

export const Body = styled.div`
  flex-shrink: 1;

  min-height: 0;
  height: 34.2rem;
  max-height: 34.2rem;

  overflow: auto;
`;
